import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useIntake } from '../../context/IntakeContext';
import { RadioGroup } from '../ui/RadioGroup';
import { MascotPanel } from '../ui/MascotPanel';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { Textarea } from '../ui/Textarea';
import { FileUpload } from '../ui/FileUpload';
import { PlusIcon, Trash2Icon } from 'lucide-react';
export function Step3Team() {
  const {
    data,
    updateData
  } = useIntake();
  const addTeamMember = () => {
    const newMember = {
      id: Date.now().toString(),
      name: '',
      role: '',
      department: '',
      bio: '',
      email: '',
      phone: '',
      linkedin: '',
      showOnSite: true,
      photo: '',
      expertise: '',
      sortOrder: ''
    };
    updateData({
      teamMembers: [...data.teamMembers, newMember]
    });
  };
  const removeTeamMember = (id: string) => {
    updateData({
      teamMembers: data.teamMembers.filter(m => m.id !== id)
    });
  };
  const updateTeamMember = (id: string, field: string, value: any) => {
    updateData({
      teamMembers: data.teamMembers.map(m => m.id === id ? {
        ...m,
        [field]: value
      } : m)
    });
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} className="max-w-3xl mx-auto space-y-8" data-id="element-288">
      <MascotPanel message="Mensen doen zaken met mensen! Een teampagina wekt vertrouwen. Wilt u uzelf of uw teamleden op de website tonen?" data-id="element-289" />

      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8" data-id="element-290">
        <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-291">
          Team & Medewerkers
        </h2>

        <div className="mb-8" data-id="element-292">
          <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-293">
            Wilt u teamleden op de website tonen?
          </label>
          <RadioGroup columns={2} value={data.showTeamOnWebsite} onChange={val => updateData({
          showTeamOnWebsite: val
        })} options={[{
          value: 'yes',
          label: 'Ja, we willen een teampagina'
        }, {
          value: 'no',
          label: 'Nee, dat is niet nodig'
        }, {
          value: 'later',
          label: 'Weet ik nog niet / later beslissen'
        }]} data-id="element-294" />
        </div>

        <AnimatePresence data-id="element-295">
          {data.showTeamOnWebsite === 'yes' && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} className="space-y-8 overflow-hidden" data-id="element-296">
              <div className="pt-6 border-t border-gray-100" data-id="element-297">
                <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-298">
                  Wil je een foto uploaden van je teamleden?
                </label>
                <RadioGroup columns={1} value={data.teamHasPhotos} onChange={val => updateData({
              teamHasPhotos: val
            })} options={[{
              value: 'yes',
              label: "Ja, ik heb foto's"
            }, {
              value: 'no_need_shoot',
              label: "Nee, ik moet nog foto's maken"
            }, {
              value: 'no_later',
              label: 'Nee, die lever ik later aan'
            }]} data-id="element-299" />
              </div>

              {data.teamHasPhotos && <div className="space-y-6" data-id="element-300">
                  <h3 className="text-lg font-bold text-gray-900" data-id="element-301">
                    Teamleden toevoegen
                  </h3>

                  {data.teamMembers.map((member, index) => <motion.div key={member.id} initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} className="p-6 bg-gray-50 rounded-2xl border border-gray-200 relative" data-id="element-302">
                      <button onClick={() => removeTeamMember(member.id)} className="absolute top-4 right-4 p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-full transition-colors" data-id="element-303">
                        <Trash2Icon className="w-5 h-5" data-id="element-304" />
                      </button>

                      <h4 className="font-semibold text-gray-900 mb-4" data-id="element-305">
                        Teamlid {index + 1}
                      </h4>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-306">
                        <Input label="Naam" value={member.name} onChange={e => updateTeamMember(member.id, 'name', e.target.value)} data-id="element-307" />
                        <Input label="Functie" value={member.role} onChange={e => updateTeamMember(member.id, 'role', e.target.value)} data-id="element-308" />
                      </div>

                      <div className="mb-4" data-id="element-309">
                        <Textarea label="Verhaaltje / Bio" value={member.bio} onChange={e => updateTeamMember(member.id, 'bio', e.target.value)} data-id="element-310" />
                      </div>

                      {data.teamHasPhotos === 'yes' && <div data-id="element-311">
                          <FileUpload label="Profielfoto" value={member.photo} onChange={url => updateTeamMember(member.id, 'photo', url)} data-id="element-312" />
                        </div>}
                    </motion.div>)}

                  <Button variant="outline" onClick={addTeamMember} className="w-full border-dashed" data-id="element-313">
                    <PlusIcon className="w-5 h-5 mr-2" data-id="element-314" />
                    Teamlid toevoegen
                  </Button>
                </div>}
            </motion.div>}
        </AnimatePresence>
      </div>
    </motion.div>;
}